import React from 'react';
import {
    Tooltip,
    OverlayTrigger,
} from "react-bootstrap";
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import SimpleReactValidator from 'simple-react-validator';
import Select from 'react-select';
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import ToggleButton from "react-toggle-button";
import { themeCSSConstants } from 'redux/constant/themeCSS';
import CreatableSelect from 'react-select';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import DatePicker from 'react-date-picker';
import { brandActions } from '../../../redux/actions/brand-actions';
import { MdClose } from 'react-icons/md';
import { FiPlus, FiSave } from 'react-icons/fi';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { FiSettings } from 'react-icons/fi'
import { Rules } from '../../../constants/TransformationRulesConstants';
import { alertActions } from '../../../redux/actions/alert-actions';
let _ = require('lodash');
var cloneDeep = require('lodash.clonedeep');

const components = {
    DropdownIndicator: null,
};

const createOption = (label) => ({
    label,
    value: label,
});

// const createLookupTableOption = (label) => {
//     if (label) {
//         return {
//             table_name: label,
//             value: label,
//         }
//     }
//     else {
//         return ''
//     }
// };
class TransformationLookupFilter extends React.Component {
    constructor(props) {
        super(props);
        this.valitdatorList = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
        // this.valitdatorList = this.props.validatorInstance;
        this.state = {
            submitted: false,
            formType: this.props.formTypePro || '',
            lookup_filters: [...OC.LOOKUP_FILTER],
            duplicate_error: {},
            inputValue: '',
            value: [],
            operand_attributes: this.props.lookup_attributes,
            startDate: null,
            date: null,
            lookupTable: this.props.lookupTables,
            lookupAttributes: this.props.lookupAttributes,
            disableAddFilter: false,
            paren_unequal: false,
            totalParen: false,
            attributesLookup: this.props.attributesLookup,
            isChanged: false,
        };
        this.handleListSubmitForm = this.handleListSubmitForm.bind(this);
    }

    popupHandler = (index) => {
        const lookup_filters = this.state.lookup_filters;
        const updated_filter = lookup_filters[index];
        updated_filter['popupHandler'] = true;
        this.setState({
            lookup_filters: lookup_filters
        })
    }

    closeHandler = (event, index) => {
        event.stopPropagation();
        const lookup_filters = this.state.lookup_filters;
        const updated_filter = lookup_filters[index];
        updated_filter['popupHandler'] = false;
        this.setState({
            lookup_filters: lookup_filters
        })
    }

    //React-select dropdown function in case of lookup_filters
    handleDropdown = (index, selectedOption, name) => {
        if (name.action === 'select-option') {
            if (name.name === 'operator') {
                if (this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.DATETIME) {
                    if (selectedOption.value === 'between' || selectedOption.value !== 'between') {
                        const lookup_filters = this.state.lookup_filters;
                        const updated_filter = lookup_filters[index];
                        updated_filter[Rules.LOOKUP_DATE];
                        updated_filter[Rules.LOOKUP_PARAM_TYPE] = 'static'
                        this.setState({
                            lookup_filters: lookup_filters
                        })
                    }
                    else {
                    }
                }
                else if (this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY] !== Rules.DATETIME) {
                    if (selectedOption.value !== this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR]) {
                        const lookup_filters = this.state.lookup_filters;
                        const updated_filter = lookup_filters[index];
                        updated_filter[Rules.LOOKUP_DATE] = null;
                        updated_filter[Rules.LOOKUP_PARAM_STATIC_VALUE] = [];
                        updated_filter[Rules.LOOKUP_STATIC_SINGLE_VALUE] = '';
                        updated_filter[Rules.LOOKUP_PARAM_FIELD_ID] = '';
                        updated_filter[Rules.LOOKUP_PARAM_FIELD] = '';
                        updated_filter[Rules.LOOKUP_PARAM_FIELD_TITLE] = '';
                        this.setState({
                            lookup_filters: lookup_filters
                        })
                    }
                    else {
                    }
                }
            }
            if (name.name === 'operand_attribute') {
                const atts = cloneDeep(this.state.lookup_filters);
                atts[index][name.name] = selectedOption.db_column;
                atts[index][name.name + '_id'] = selectedOption.id;
                atts[index][name.name + '_title'] = selectedOption.title;
                atts[index][Rules.LOOKUP_OPERATOR_CATEGORY] = selectedOption.data_type;
                atts[index][Rules.LOOKUP_OPERATOR] = '';
                this.setState({ lookup_filters: atts }, () => {
                    if (this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY] !== Rules.DATETIME) {
                        const lookup_filters = this.state.lookup_filters;
                        const updated_filter = lookup_filters[index];
                        updated_filter[Rules.LOOKUP_DATE] = null;
                        this.setState({
                            lookup_filters: lookup_filters
                        })
                    }
                });
            }
            else if (name.name === 'param_field') {
                const atts = [...this.state.lookup_filters];
                const updatedfilter = atts[index];
                updatedfilter[name.name] = selectedOption.db_column;
                updatedfilter[name.name + '_id'] = selectedOption.id;
                updatedfilter[name.name + '_title'] = selectedOption.title;
                this.setState({ lookup_filters: atts });
            }
            else {
                const atts = cloneDeep(this.state.lookup_filters);
                atts[index][name.name] = selectedOption.value;
                this.setState({ lookup_filters: atts }, () => {
                    if (name.name === 'param_type') {
                        if (selectedOption.value === 'field') {
                            const atts = cloneDeep(this.state.lookup_filters);
                            atts[index][Rules.LOOKUP_PARAM_STATIC_VALUE] = [];
                            atts[index][Rules.LOOKUP_STATIC_SINGLE_VALUE] = '';
                            this.setState({ lookup_filters: atts })
                        }
                        if (selectedOption.value === 'static') {
                            const atts = cloneDeep(this.state.lookup_filters);
                            atts[index][Rules.LOOKUP_PARAM_FIELD] = '';
                            atts[index][Rules.LOOKUP_PARAM_FIELD_ID] = '';
                            atts[index][Rules.LOOKUP_PARAM_FIELD_TITLE] = '';
                            this.setState({ lookup_filters: atts })
                        }
                    }
                    if (name.name === 'logical_operator') {
                        if (selectedOption.value === 'none') {
                            const lookup_filters = this.state.lookup_filters;
                            const newArray = lookup_filters.splice(0, index + 1)
                            this.setState({
                                lookup_filters: newArray,
                                disableAddFilter: true
                            })
                        }
                        else if (selectedOption.value === 'or' || selectedOption.value === 'and') {
                            this.setState({
                                disableAddFilter: false
                            })
                        }
                        else {

                        }
                    }
                });
            }
        }
    }

    onCheckFlag = (toggle, rowIndex, name) => {
        const atts = cloneDeep(this.state.lookup_filters);
        atts[rowIndex][name] = !toggle;
        this.setState({ lookup_filters: atts }, () => {
        });
    }
    onInputHandler = (e, rowIndex) => {
        const atts = cloneDeep(this.state.lookup_filters);
        if (e.target.type === Rules.TEXT || e.target.type === 'select-one') {
            const { name, value } = e.target;
            atts[rowIndex][name] = value;
        }
        else if (e.target.type === 'checkbox') {
            const { name, checked } = e.target;
            atts[rowIndex][name] = checked;
        }
        this.setState({ lookup_filters: atts });
    }

    handleCheckStatus = (e) => {
        const { name, checked } = e.target;
        this.setState({
            brand_order_attributes: {
                ...this.state.brand_order_attributes,
                [name]: checked,
            }
        })
    }
    handleDateChange = (index, name, date) => {
        const lookup_filters = this.state.lookup_filters;
        const updated_filter = lookup_filters[index];
        updated_filter[name] = date;
        updated_filter[Rules.LOOKUP_PARAM_STATIC_VALUE] = [];
        updated_filter[Rules.LOOKUP_PARAM_FIELD] = '';
        updated_filter[Rules.LOOKUP_PARAM_FIELD_ID] = '';
        updated_filter['dateRange'] = '';
        this.setState({
            lookup_filters: lookup_filters
        })
    }
    handleAddFilter = (e) => {

        e.preventDefault();
        const atts = cloneDeep(this.state.lookup_filters);
        atts.push(...OC.LOOKUP_FILTER);
        this.setState({
            lookup_filters: atts,
            disableAddFilter: true
        })
    }
    handleOnFocusSettingsIcon = (e, index) => {
        if (this.state.lookup_filters[index][Rules.LOOKUP_HAS_ERROR]) {
            const atts = cloneDeep(this.state.lookup_filters);
            atts[index][Rules.LOOKUP_HAS_ERROR] = false;
            this.setState({ lookup_filters: atts })
        }
    }
    createTable = (filters) => {
        return filters.map((data, index) => {
            return <tr key={index} >

                {/* Not */}
                <td className="">
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={data[Rules.LOOKUP_APPLY_NOT] ? data[Rules.LOOKUP_APPLY_NOT] : ''}
                        name={Rules.LOOKUP_APPLY_NOT}
                        onToggle={(e) => this.onCheckFlag(e, index, Rules.LOOKUP_APPLY_NOT)}
                    />
                </td>

                {/* Paren start */}
                <td>
                    <select className="form-control" onChange={(e) => this.onInputHandler(e, index)} style={this.state.paren_unequal || this.state.totalParen ? { border: '1px solid red' } : null} name={Rules.LOOKUP_PARENTHESIS_START}
                        value={data[Rules.LOOKUP_PARENTHESIS_START] ? data[Rules.LOOKUP_PARENTHESIS_START] : ""} >
                        {
                            OC.OPENING_PARENTHESIS.map((value, index) => (
                                <option value={value.value} key={index} > {value.label} </option>
                            ))
                        }
                    </select>
                </td>

                {/* Attribute  */}
                <td>
                    <Select
                        // value={HF.returnLabelWithValue(this.state.lookup_filters[index]., OC.dataTypeList)}
                        name={Rules.LOOKUP_OPERAND_ATTRIBUTE}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.props.lookup_attributes}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        className='text-capitalize'
                        isSearchable={true}
                        isMulti={false}
                        placeholder={'Choose Attribute'}
                        isClearable={false}
                    />
                    {this.valitdatorList.message('Attribute', this.state.lookup_filters[index][Rules.LOOKUP_OPERAND_ATTRIBUTE], 'required')}
                </td>

                {/* Operator */}
                <td>
                    <Select
                        value={HF.returnLabelWithValue(this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR], this.returnOperatorsList(this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY]))}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY] ?
                            this.returnOperatorsList(this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY]) : []}
                        isSearchable={true}
                        name={Rules.LOOKUP_OPERATOR}
                        className='text-capitalize'
                        isMulti={false}
                        placeholder={'Choose Operator'}
                        isClearable={false}
                    />
                    {this.valitdatorList.message('Operator', this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR], 'required')}
                </td>

                {/* Param Type */}
                <td>
                    <Select
                        value={HF.returnLabelWithValue(this.state.lookup_filters[index][Rules.LOOKUP_PARAM_TYPE], OC.LOOKUP_FILTERS_PARAM_TYPES)}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.returnParamTypes(this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY], index)}
                        isSearchable={true}
                        name={Rules.LOOKUP_PARAM_TYPE}
                        className='text-capitalize'
                        isMulti={false}
                        placeholder={'Choose Option'}
                        isClearable={false}
                        isDisabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false}
                    />
                    {
                        this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] !== 'empty' ?
                            this.valitdatorList.message('Attribute', this.state.lookup_filters[index][Rules.LOOKUP_PARAM_TYPE], 'required')
                            : null
                    }
                </td>

                {/* Params */}
                <td className="text-center">
                    <span className="customPopupContainer" onClick={() => this.popupHandler(index)}>
                        <OverlayTrigger placement="top" overlay={
                            <Tooltip id="setParam">Click here to set parameter</Tooltip>
                        }>
                            <span className="paramIcon text-sm" style={this.state.lookup_filters[index][Rules.LOOKUP_HAS_ERROR] ? { color: 'red' } : null} ><FiSettings /></span>
                        </OverlayTrigger>
                        {
                            <div className={"customPopup text-left " + (this.state.lookup_filters[index][Rules.LOOKUP_POPUP_HANDLER] ? "" : "hidden")} onFocus={(event) => this.handleOnFocusSettingsIcon(event, index)}  >
                                <span className="closePopup" onClick={(event) => this.closeHandler(event, index)}>
                                    <MdClose />
                                </span>
                                {
                                    this.returnParamField(this.state.lookup_filters[index][Rules.LOOKUP_PARAM_TYPE], this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR_CATEGORY], this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR], index)
                                }

                                <div className="text-center">
                                    <button type="button" onClick={(event) => this.closeHandler(event, index)} style={{ width: 'auto' }} className="customBtn pt-xs pb-xs mt-xs pr-sm pl-sm btnBlue">Save</button>
                                </div>
                            </div>
                        }
                    </span>
                </td>

                {/* Parens */}
                <td>
                    <select className="form-control" onChange={(e) => this.onInputHandler(e, index)} style={this.state.paren_unequal || this.state.totalParen ? { border: '1px solid red' } : null} name={Rules.LOOKUP_PARENTHESIS_END}
                        value={data[Rules.LOOKUP_PARENTHESIS_END] ? data[Rules.LOOKUP_PARENTHESIS_END] : ""} >
                        {
                            OC.CLOSING_PARENTHESIS.map((value, index) => (
                                <option value={value.value} key={index} > {value.label} </option>
                            ))
                        }
                    </select>

                </td>

                {/* And/OR */}
                <td>
                    <div style={{ position: 'relative' }}>

                        <Select
                            value={HF.returnLabelWithValue(this.state.lookup_filters[index][Rules.LOOKUP_LOGICAL_OPERATOR], OC.GATES)}
                            onChange={(e, name) => this.handleDropdown(index, e, name)}
                            options={this.returnGatesList(this.state.lookup_filters[index][Rules.LOOKUP_LOGICAL_OPERATOR])}
                            isSearchable={true}
                            className='text-capitalize'
                            name={'logical_operator'}
                            isMulti={false}
                            placeholder={'Select AND/OR'}
                            isClearable={false}
                        />
                        {
                            this.state.lookup_filters.length > 1 &&
                            <div className="removeFilterContainer">
                                <OverlayTrigger
                                    placement="left"
                                    overlay={
                                        <Tooltip id="removeFilter">Remove Filter</Tooltip>
                                    }>
                                    <span className="removeFilter" onClick={this.removeFilter}>
                                        <MdClose />
                                    </span>
                                </OverlayTrigger>
                            </div>
                        }
                    </div>
                </td>
            </tr>
        })
    }

    getFormattedDate = (date) => {
        if (Array.isArray(date)) {
            return date.map(item => {
                if (item !== '' && item !== null) {
                    const formattedDate = new Date(item);
                    return (formattedDate.getMonth() + 1) + '/' + formattedDate.getDate() + '/' + formattedDate.getFullYear() + ' '
                } else {
                    return ''
                }
            })
        }
        else {
            if (date !== '' && date !== null) {
                const formattedDate = new Date(date);
                return (formattedDate.getMonth() + 1) + '/' + formattedDate.getDate() + '/' + formattedDate.getFullYear()
            } else {
                return ''
            }
        }
    }

    removeFilter = (e) => {
        e.preventDefault();
        const filters = this.state.lookup_filters;
        const newArray = filters.slice(0, (filters.length - 1))
        if (filters.length > 1)
            this.setState({
                lookup_filters: newArray
            })
        else
            this.setState({
                lookup_filters: [],
                disableAddFilter: false
            })
    }
    warningMsg = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="row" msgType='warning' description={"Add at least one filter that contains the same Lookup table as in Set Statement"} onClosePro={onClose} />
                )
            }
        })
    }

    handleListSubmitForm(e) {
        e.preventDefault();
        if (this.valitdatorList.allValid()) {
            let numOfStartParens = 0;
            let numOfEndParens = 0;
            const newArray = [];
            let labels;
            let obj = {};
            this.state.lookup_filters.forEach(item => {
                numOfStartParens += item[Rules.LOOKUP_PARENTHESIS_START].length
                numOfEndParens += item[Rules.LOOKUP_PARENTHESIS_END].length
                // const labels = item.param_static_value.map(element => {
                //     return element.label
                // })
                if (Array.isArray(item.param_static_value)) {
                    labels = item.param_static_value.map(element => {
                        return element.label
                    })
                }
                if (item[Rules.LOOKUP_DATE] !== null) {
                    if (Array.isArray(item[Rules.LOOKUP_DATE])) {
                        newArray.push({
                            ...item,
                            // param_static_value: this.getFormattedDate(item[Rules.LOOKUP_DATE]),
                            param_static_value: item[Rules.LOOKUP_DATE],
                        })
                    }
                    else {
                        newArray.push({
                            ...item,
                            // param_static_value: [this.getFormattedDate(item[Rules.LOOKUP_DATE])],
                            param_static_value: [item[Rules.LOOKUP_DATE]],
                        })
                    }
                }
                else if (item[Rules.LOOKUP_STATIC_SINGLE_VALUE]) {
                    newArray.push({
                        ...item,
                        param_static_value: [item[Rules.LOOKUP_STATIC_SINGLE_VALUE]],
                    })
                }
                else {
                    newArray.push({
                        ...item,
                        param_static_value: labels
                    })
                }
            });
            if (numOfStartParens !== numOfEndParens) {
                this.setState({
                    totalParen: true
                })
            }
            obj = {
                lookup_filters: newArray
            }
            obj.lookup_filters = this.createRuleFiltersExpressions(obj.lookup_filters);
            console.log('%c The child compponent is', 'color:brown', obj);
            // In case of not working remove the upper lookup logic
            if (numOfStartParens === numOfEndParens && !this.state.paren_unequal) {
                this.props.handleLookupFilterSubmit(obj.lookup_filters, this.props.type, this.props.rowIndex);
                this.setState({
                    isChanged: false
                })
                return;
            }

        }
        else {
            this.setState({ submitted: false });
            this.valitdatorList.showMessages();
            this.forceUpdate();
            const newArray = [];
            let labels;
            this.state.lookup_filters.forEach(item => {
                if (Array.isArray(item.param_static_value)) {
                    labels = item.param_static_value.map(element => {
                        return element.label
                    })
                }
                if (item[Rules.LOOKUP_DATE] !== null) {
                    if (Array.isArray(item[Rules.LOOKUP_DATE])) {
                        item.param_static_value = item[Rules.LOOKUP_DATE];
                    }
                    else {
                        item.param_static_value = [item[Rules.LOOKUP_DATE]];
                    }
                }
                else if (item[Rules.LOOKUP_STATIC_SINGLE_VALUE]) {
                    item.param_static_value = [item[Rules.LOOKUP_STATIC_SINGLE_VALUE]];
                }
                else {
                    item.param_static_value = labels
                }
                // icon red logic
                if (item[Rules.LOOKUP_PARAM_TYPE] === 'static') {
                    if (Array.isArray(item.param_static_value)) {
                        if (item.param_static_value.length === 0) {
                            item[Rules.LOOKUP_HAS_ERROR] = true;
                        }
                        else if (item.param_static_value.length > 0) {
                            item[Rules.LOOKUP_HAS_ERROR] = false
                        }
                    }
                    else {
                        if (!item.param_static_value) {
                            item[Rules.LOOKUP_HAS_ERROR] = true;
                        }
                        else if (item.param_static_value) {
                            item[Rules.LOOKUP_HAS_ERROR] = false
                        }
                    }
                }
                else if (item[Rules.LOOKUP_PARAM_TYPE] === 'field') {
                    if (!item[Rules.LOOKUP_PARAM_FIELD]) {
                        item[Rules.LOOKUP_HAS_ERROR] = true;
                    }
                    else if (item[Rules.LOOKUP_PARAM_FIELD]) {
                        item[Rules.LOOKUP_HAS_ERROR] = false
                    }
                }
                else if (item[Rules.LOOKUP_PARAM_TYPE] === 'lookup') {
                    if (!item.param_lookup_table) {
                        item[Rules.LOOKUP_HAS_ERROR] = true;
                    }
                    else if (item.param_lookup_table) {
                        item[Rules.LOOKUP_HAS_ERROR] = false
                    }
                    if (!item.param_lookup_table_column) {
                        item[Rules.LOOKUP_HAS_ERROR] = true;
                    }
                    else if (item.param_lookup_table_column) {
                        item[Rules.LOOKUP_HAS_ERROR] = false;
                    }
                }
                else if (item[Rules.LOOKUP_OPERATOR] === 'empty') {
                    item[Rules.LOOKUP_HAS_ERROR] = false
                }
                newArray.push(item);
            });
            this.setState({
                lookup_filters: newArray
            })
        }


    }
    returnOperatorsList(data_type) {
        switch (data_type) {
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.INT_OPERATORS;
            case Rules.STRING:
            case Rules.TEXT:
                return OC.STRING_OPERATORS;
            case Rules.DATETIME:
                return OC.DATE_OPERATORS;
            case Rules.URL:
                return OC.URL_OPERATORS;
            default:
                return [];
        }
    }
    returnParamTypes(type, index) {
        if (type !== 'datetime' && this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'any of') {
            return OC.LOOKUP_FILTERS_PARAM_TYPES;
        }
        switch (type) {
            case Rules.DATETIME:
                return OC.LOOKUP_FILTERS_PARAM_TYPES;
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.LOOKUP_FILTERS_PARAM_TYPES;
            default:
                return OC.LOOKUP_FILTERS_PARAM_TYPES;
        }
    }
    returnGatesList(gate) {
        switch (gate) {
            case 'none':
                return OC.GATES;
            case 'and':
                return OC.GATES;
            case 'or':
                return OC.GATES;
            default:
                return OC.GATES;
        }
    }
    returnActionsList(data_type) {
        switch (data_type) {
            case Rules.INTEGER:
            case Rules.FLOAT:
                return OC.TARGET_ATTRIBUTE_ACTIONS_INT;
            case Rules.STRING:
            case Rules.TEXT:
                return OC.TARGET_ATTRIBUTE_ACTIONS_STRING;
            case Rules.DATETIME:
                return OC.TARGET_ATTRIBUTE_ACTIONS_DATE;
            case Rules.URL:
                return OC.TARGET_ATTRIBUTE_ACTIONS_URL
            default:
                return [];
        }
    }
    returnParamField(param_type, operator_category, operator, index) {
        if (param_type === 'static' && operator_category === Rules.DATETIME) {
            if (operator === 'between') {
                return <span>
                    <DateRangePicker
                        className="form-control"
                        onChange={(e) => this.handleDateChange(index, "date", e)}
                        value={this.state.lookup_filters[index][Rules.LOOKUP_DATE]}
                        placeholderText={`11/06/2019 - 11/22/2019`}
                    />
                    {
                        this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] !== 'empty' ?
                            this.valitdatorList.message('Param', this.state.lookup_filters[index][Rules.LOOKUP_DATE], 'required')
                            : null
                    }
                </span>
            }
            else {
                return <span>
                    <DatePicker
                        className="form-control"
                        value={this.state.lookup_filters[index][Rules.LOOKUP_DATE]}
                        onChange={(e) => this.handleDateChange(index, "date", e)}
                        placeholderText={`11/06/2019`}
                    />
                    {
                        this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] !== 'empty' ?
                            this.valitdatorList.message('Param', this.state.lookup_filters[index][Rules.LOOKUP_DATE], 'required')
                            : null
                    }
                </span>
            }
        }
        else if (param_type === 'static' && operator_category !== Rules.DATETIME) {
            switch (operator) {
                // integer cases start
                case 'equals to':
                case 'greater than':
                case 'greater than or equal':
                case 'less than':
                case 'less than or equal':
                // integer cases end
                //string cases start
                case 'empty':
                case 'begins with':
                case 'ends with':
                case 'contains':
                    //string cases end
                    return <span>
                        <label htmlFor="param_static_value">Add Value:</label>
                        <input type="text" name="static_single_value" value={this.state.lookup_filters[index][Rules.LOOKUP_STATIC_SINGLE_VALUE]} className="form-control"
                            disabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false} onChange={(e) => this.onInputHandler(e, index)} />
                        {
                            this.valitdatorList.message('Param', this.state.lookup_filters[index][Rules.LOOKUP_STATIC_SINGLE_VALUE], 'required')
                        }
                    </span>
                case 'between':
                case 'any of':
                    return <span>
                        <label htmlFor="param_static_value">Add Values:</label>
                        <CreatableSelect
                            components={components}
                            inputValue={this.state.lookup_filters[index][Rules.LOOKUP_CREATABLE_VALUE]}
                            isClearable
                            isMulti
                            key={index}
                            menuIsOpen={false}
                            onChange={(event, action) => this.handleCreatableChange(index, "param_static_value", event, action)}
                            onInputChange={(event, action) => this.handleCreatableInputChange(index, "param_static_value", event)}
                            onKeyDown={e => this.handleCreatableKeyDown(e, index, "param_static_value")}
                            name="param_static_value"
                            placeholder="Type something and press tab"
                            value={this.state.lookup_filters[index].param_static_value}
                            isDisabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false}
                        />
                        {this.state.duplicate_error[index] && <span style={{ color: 'red' }}>Value already exists in the list.</span>}
                        {
                            this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] !== 'empty' ?
                                this.valitdatorList.message('Param', this.state.lookup_filters[index].param_static_value, 'required')
                                : null
                        }
                    </span>
                default:
                    return <span></span>
            }
        }

        else if (param_type === 'lookup') {
            return <div>
                <div className="formLabel">Lookup Table</div>
                <span>
                    <Select
                        // value={HF.returnLabelWithValue(this.state.lookup_filters[index][Rules.LOOKUP_LOGICAL_OPERATOR], OC.GATES)}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.state.attributesLookup}
                        isSearchable={true}
                        className='text-capitalize'
                        key={index}
                        name={'param_lookup_table'}
                        getOptionLabel={(option) => option.table_name}
                        getOptionValue={(option) => option.id}
                        isMulti={false}
                        placeholder={'Lookup Table'}
                        isClearable={false}
                        isDisabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false}
                    />
                    {this.valitdatorList.message('Lookup Table', this.state.lookup_filters[index].param_lookup_table, 'required')}
                </span>
                <div className="formLabel">Lookup Attribute</div>
                <span>
                    <Select
                        value={HF.returnTitleWithDb_column(this.state.lookup_filters[index].param_lookup_table_column, this.returnRuleFiltersLookupAttributes(index, this.state.lookup_filters[index]['param_lookup_table']))}
                        onChange={(e, name) => this.handleDropdown(index, e, name)}
                        options={this.returnRuleFiltersLookupAttributes(index, this.state.lookup_filters[index]['param_lookup_table'])}
                        isSearchable={true}
                        className='text-capitalize'
                        key={index + 1}
                        name={'param_lookup_table_column'}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.id}
                        isMulti={false}
                        placeholder={'Lookup Attribute'}
                        isClearable={false}
                        isDisabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false}
                    />
                    {this.valitdatorList.message('Lookup Attribute', this.state.lookup_filters[index].param_lookup_table_column, 'required')}
                </span>
            </div>
        }

        else {
            return <div className="form-group">
                <div className="formLabel">Value Attribute</div>
                <Select
                    value={HF.returnTitleWithId(this.state.lookup_filters[index][Rules.LOOKUP_PARAM_FIELD_ID], this.props.attributesProp)}
                    name={'param_field'}
                    onChange={(e, name) => this.handleDropdown(index, e, name)}
                    options={this.props.attributesProp}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.id}
                    className='text-capitalize'
                    isSearchable={true}
                    isMulti={false}
                    placeholder={'Choose Attribute'}
                    isClearable={false}
                    isDisabled={this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] === 'empty' ? true : false}
                />
                {
                    this.state.lookup_filters[index][Rules.LOOKUP_OPERATOR] !== 'empty' ?
                        this.valitdatorList.message('Param', this.state.lookup_filters[index][Rules.LOOKUP_PARAM_FIELD], 'required')
                        : null
                }
            </div>
        }
    }

    handleCreatableChange = (index, name, value, actionMeta) => {
        const lookup_filters = this.state.lookup_filters;
        const updated_filter = lookup_filters[index];
        updated_filter[name] = value;
        this.setState({
            lookup_filters: lookup_filters
        })

    };
    handleCreatableInputChange = (index, name, inputValue) => {
        const atts = cloneDeep(this.state.lookup_filters);
        atts[index]['creatable_value'] = inputValue;
        this.setState({ lookup_filters: atts }, () => { })

    };
    handleCreatableKeyDown = (event, index, name) => {
        if (!this.state.lookup_filters[index][Rules.LOOKUP_CREATABLE_VALUE]) return;
        switch (event.key) {
            case 'Tab':
            case 'Enter':
                const atts = cloneDeep(this.state.lookup_filters);
                atts[index][name] = [...this.state.lookup_filters[index].param_static_value, createOption(this.state.lookup_filters[index][Rules.LOOKUP_CREATABLE_VALUE])];
                const params = this.state.lookup_filters[index].param_static_value.map((item, key) => {
                    return item.label
                })
                if (params.includes(this.state.lookup_filters[index][Rules.LOOKUP_CREATABLE_VALUE])) {
                    this.setState({
                        duplicate_error: {
                            ...this.state.duplicate_error,
                            [index]: true
                        },
                    })
                    event.preventDefault();
                    return
                }
                this.setState({
                    ...this.state,
                    duplicate_error: {
                        ...this.state.duplicate_error,
                        [index]: false
                    },
                    lookup_filters: atts
                },
                    () => {
                        const atts = cloneDeep(this.state.lookup_filters);
                        atts[index]['creatable_value'] = '';
                        this.setState({ lookup_filters: atts })
                    })
                event.preventDefault();
                break;
            default:
                return ''
        }
    };

    returnRuleFiltersLookupAttributes = (rowIndex, table_name) => {
        const { attributesLookup, lookup_filters } = this.state;
        const titles = attributesLookup.map(data => {
            return data.table_name;
        });
        const index = titles.indexOf(table_name);
        if (index >= 0) {
            if (lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.STRING || lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.TEXT) {
                const stringArray = attributesLookup[index].attributes;
                return stringArray;
            }
            else if (lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.INTEGER || lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.FLOAT) {
                const integerArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.INTEGER || data.data_type === Rules.FLOAT || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return integerArray;
            }
            else if (lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.INTEGER) {
                const dateArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.DATETIME || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return dateArray;
            }
            else if (lookup_filters[rowIndex][Rules.LOOKUP_OPERATOR_CATEGORY] === Rules.URL) {
                const urlArray = attributesLookup[index].attributes.filter((data, row) => {
                    if (data.data_type === Rules.URL || data.data_type === Rules.STRING || data.data_type === Rules.TEXT) {
                        return data;
                    }
                })
                return urlArray;
            }
            else {
                return [];
            }
        }
        return [];
    }
    returnTargetValueTypes = (action) => {
        switch (action) {
            case 'add':
            case 'subtract':
            case 'multiply':
            case 'divide':
            case 'append':
            case 'prepend':
            case 'add date':
            case 'add day':
            case 'add month':
            case 'add year':
            case 'subtract date':
            case 'subtract day':
            case 'subtract month':
            case 'subtract year':
                return OC.LOOKUP_FILTERS_PARAM_TYPES;
            case 'set':
                return OC.LOOKUP_FILTERS_PARAM_TYPES;
            default:
                return [];
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(this.state.lookup_filters, prevState.lookup_filters)) {
            let start = 0;
            let end = 0;
            let sum = 0;
            this.state.lookup_filters.forEach((item, index) => {
                start += item[Rules.LOOKUP_PARENTHESIS_START].length;
                end += item[Rules.LOOKUP_PARENTHESIS_END].length;
            })
            sum = start - end;
            if (sum < 0 && !this.state.paren_unequal) {
                this.setState({
                    ...this.state,
                    paren_unequal: true,
                    totalParen: false,
                    disableAddFilter: true,
                    isChanged: true
                }, () => {
                })
            }
            if (sum >= 0 && this.state.paren_unequal) {
                this.setState({
                    ...this.state,
                    paren_unequal: false,
                    totalParen: false,
                    disableAddFilter: false,
                    isChanged: true
                }, () => {
                })
            }
            if (sum <= 0 && this.state.totalParen) {
                this.setState({
                    totalParen: false,
                    isChanged: true
                })
            }

            this.setState({
                isChanged: true
            })
        }
    }

    createRuleFiltersExpressions = (lookup_filters) => {
        let expressionArray;
        const actionFiltersArray = lookup_filters.map((rule, index) => {
            if (rule.param_type === 'static') {
                if (Array.isArray(rule.param_static_value)) {
                    rule.param_value = rule.param_static_value;
                }
                else {
                    rule.param_value = [rule['param_static_value']];
                }
            }
            else if (rule.param_type === 'field') {
                rule.param_value = [rule['param_field']];
                rule.param_title = rule.param_field_title;
            }
            else if (rule.param_type === 'lookup') {
                rule.param_value = [rule['param_lookup_table'], rule['param_lookup_table_column']];
                rule.param_title = rule.param_lookup_table_column_title;
            }
            else if (rule.operator === 'empty') {
                rule.param_value = ['']
                rule.param_type = 'static';
            }
            rule.actions = expressionArray;
            return rule;
        })
        return actionFiltersArray;
    }
    render() {
        this.valitdatorList.purgeFields();
        const { lookup_filters } = this.state;
        return (<React.Fragment>
            {
                <div className={this.props.borderClass ? "childFilterContainer" : "childFilterRow"}>
                    <h6 className="mt-none" style={{ color: '#1684e4' }}>
                        How to lookup / filter matching records
                        </h6>
                    <table className="table table-striped" style={{ marginBottom: '0' }}>
                        <thead>
                            <tr>
                                <td width="4%">Not</td>
                                <td width="6%">Parens *</td>
                                <td width="10%">Attribute *</td>
                                <td width="10%">Operator *</td>
                                <td width="10%">Param Type *</td>
                                <td width="10%">Param (s)*</td>
                                <td width="6%">Parens *</td>
                                <td width="7%">AND/OR *</td>
                            </tr>
                        </thead>

                        <tbody className="rulesFilterContainer">
                            {
                                this.createTable(lookup_filters)
                            }
                        </tbody>
                    </table>
                </div>
            }

            <div className="row">
                <div className="col-md-12">
                    <div className='text-right'>
                        <button className="smallActionBtn m-sm btnSave" disabled={this.state.isChanged ? false : true} type='button' onClick={this.handleListSubmitForm}> <FiSave /> <span> Save</span></button>
                        <button className="smallActionBtn m-sm btnDefault" onClick={this.handleAddFilter} disabled={this.state.disableAddFilter}><FiPlus /> <span>Add</span></button>
                    </div>
                </div>
            </div>
        </React.Fragment>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return ({
        storeTransformationRulesCall: (data, id) => { return dispatch(brandActions.storeTransformationRules(data, id)) },
        successMessage: (message) => { dispatch(alertActions.success(message)) }
    });
};
function mapStateToProps(state) {
    const { storedRule } = state.brandReducer;
    return {
        storedRule,
    };
}

const LookupFilter = connect(mapStateToProps, mapDispatchToProps)(TransformationLookupFilter);
export default LookupFilter;



// WEBPACK FOOTER //
// ./src/components/Admin/Brands/TrasformationLookupFilter.jsx